/* Core & libraries */
import React, {useEffect, useState} from "react";
import {useTheme} from "react-jss";
import {FormattedMessage} from "react-intl";

/* Helpers, constants, custom methods, internal libraries */


/* Components */
import UCModal from "../../ucmodal";
import Content from "./content";
import {ReactComponent as StarSvg} from '../../../resources/images/star.svg';
import {ReactComponent as DeleteIconRed} from "resources/images/delete-icon.svg";
import UCButton from "components/buttons";

/* Styles */
import styles from "./styles";

const LoyaltyDeleteAllFailedModal = ({gridData, applyFilters, getLoyaltyList}) => {
  const theme = useTheme();
  const classes = styles({theme});

  const [showLoyaltyDeleteAllFailedModal, setShowLoyaltyDeleteAllFailedModal] = useState(false)

  return (
    <>
      <UCButton
        onClick={() => setShowLoyaltyDeleteAllFailedModal(true)}
        type="defaultLink"
        className={classes.deleteAllBtn}
        text={<FormattedMessage id="redemptionHistory.grid.header.filters.deleteAll"/>}
        icon={<DeleteIconRed/>}
        textClassName={classes.deleteAllBtnText}
      />
      <UCModal
        className={classes.loyaltyDeleteAllFailedModal}
        showModal={showLoyaltyDeleteAllFailedModal}
        setShowModal={setShowLoyaltyDeleteAllFailedModal}
        modalIcon={<StarSvg/>}
        modalTitle={<FormattedMessage id="loyaltyDeleteAllFailedModal.title"/>}
        modalDescription={<FormattedMessage id="loyaltyDeleteAllFailedModal.description"/>}
        modalContent={<Content setShowModal={setShowLoyaltyDeleteAllFailedModal} gridData={gridData} applyFilters={applyFilters} getLoyaltyList={getLoyaltyList}/>}
        dataTestId="loyaltyDeleteAllFailedModal"
      />
    </>
  )
}

export default LoyaltyDeleteAllFailedModal;